<template>
  <div class="app-view-personal-data">
    <ShowPersonalData :customer="currentCustomer">
      <template v-for="slot in possibleChildSlotsFor('PersonalData')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ShowPersonalData>
    <SendVerificationMail>
      <template v-for="slot in possibleChildSlotsFor('Verification')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SendVerificationMail>
  </div>
</template>

<script>
import { wrapQuery } from '../../../../../helper/wrapGQLQuery'
import gql from 'graphql-tag'
import ShowPersonalData from '@/components/process/generic/PersonalData/ShowPersonalData.vue'
import slotProxy from '../../../../../mixins/slotProxy'
import SendVerificationMail from '@/components/process/generic/PersonalData/fyve/SendVerificationMail.vue'

export default {
  name: 'ViewPersonalData',
  components: { SendVerificationMail, ShowPersonalData },
  data () {
    return {
      currentCustomer: {
        salutation: '',
        firstName: '',
        lastName: '',
        birthDate: '',
        address: {
          city: '',
          houseNumber: '',
          street: '',
          supplement: '',
          zip: ''
        },
        email: ''
      }
    }
  },
  mixins: [
    slotProxy()
  ],
  apollo: {
    currentCustomer: function () {
      return wrapQuery(
        gql`query personalData{
          currentCustomer {
            salutation,
            firstName,
            birthDate,
            lastName,
            address {
              city,
              houseNumber,
              street,
              supplement,
              zip
            },
            email
          }
        }`, this, 'currentCustomer', {}, null,
        {
          fetchPolicy: 'cache-first'
        }
      )
    }
  }
}
</script>
